// extracted by mini-css-extract-plugin
export default {"card":"countryCard_card__szx2+","thumbnail":"countryCard_thumbnail__16em6","detail":"countryCard_detail__0wJYH"};